import * as Yup from 'yup'

// --------------------
// PASSWORD RULES
// --------------------

/** At least 8 chars, one letter, one digit, one special char, and no whitespace. */
export const PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])(?=\S+$).{8,}$/

export const SIGNUP_PASSWORD_MESSAGE =
  'Passwort darf keine Leerzeichen enthalten und muss mindestens 8 Zeichen, einen Buchstaben, eine Zahl und mindestens eins dieser Sonderzeichen (@, $, !, %, *, ?, &) enthalten.'

export const PASSWORD_RESET_MESSAGE =
  'Passwort darf keine Leerzeichen enthalten und muss mindestens 8 Zeichen, einen Buchstaben, eine Zahl und ein Sonderzeichen enthalten.'

// --------------------
// SIGNUP
// --------------------

export interface SignupData {
  salutation: string
  firstname: string
  lastname: string
  company: string
  email: string
  password: string
  street: string
  streetNumber: string
  postal: string
  city: string
  country: string
  workingArea: string
  workRadius: string
  salesRegion: string
  topics: string[]
}

export const SignupSchema = Yup.object({
  salutation: Yup.string().optional(),
  firstname: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  lastname: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  email: Yup.string()
    .email('Ungültige E-Mail-Adresse')
    .required('Dieses Feld darf nicht leer sein.'),
  password: Yup.string()
    .required(SIGNUP_PASSWORD_MESSAGE)
    .matches(PASSWORD_PATTERN, SIGNUP_PASSWORD_MESSAGE),
  street: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  streetNumber: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  postal: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  city: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  country: Yup.string().required('Dieses Feld darf nicht leer sein.'),
  workRadius: Yup.string().optional(),
  salesRegion: Yup.string().optional(),
  topics: Yup.array().of(Yup.string()).optional(),
})

export const INITIAL_SIGNUP_VALUES: SignupData = {
  salutation: '',
  firstname: '',
  lastname: '',
  company: '',
  email: '',
  password: '',
  street: '',
  streetNumber: '',
  postal: '',
  city: '',
  country: 'Deutschland',
  workingArea: '',
  workRadius: '',
  salesRegion: '',
  topics: [],
}

// --------------------
// LOGIN
// --------------------

export interface SigninData {
  email: string
  password: string
}
export const SigninSchema = Yup.object({
  email: Yup.string()
    .email('Bitte geben Sie eine gültige E-Mail-Adresse ein.')
    .required('E-Mail ist erforderlich.'),
  password: Yup.string().required('Kennwort ist erforderlich.'),
})

export const INITIAL_SIGNIN_VALUES: SigninData = {
  email: '',
  password: '',
}

// --------------------
// PASSWORD RESET
// --------------------

export interface PasswordResetData {
  password: string
  confirm: string
}

export const PasswordResetSchema = Yup.object({
  password: Yup.string()
    .required('Kennwort ist erforderlich')
    .matches(PASSWORD_PATTERN, PASSWORD_RESET_MESSAGE)
    .min(8, 'Das Kennwort muss mindestens 8 Zeichen lang sein'),
  confirm: Yup.string()
    .oneOf([Yup.ref('password'), ''], 'Kennwörter stimmen nicht überein')
    .required('Bitte wiederholen Sie das Kennwort'),
})

export const INITIAL_PASSWORD_RESET_VALUES: PasswordResetData = {
  password: '',
  confirm: '',
}

// --------------------
// FORGOT PASSWORD
// --------------------

export interface ForgotPasswordData {
  email: string
}

export const ForgotPasswordSchema = Yup.object({
  email: Yup.string()
    .email('Bitte geben Sie eine gültige E-Mail-Adresse ein.')
    .required('E-Mail-Adresse ist erforderlich.'),
})

export const INITIAL_FORGOT_PASSWORD_VALUES: ForgotPasswordData = {
  email: '',
}
